module.exports = __webpack_public_path__ + "img/MLS-clear.ca3ed0ef.png";